export default {
  modal: {
    submitButton: 'dt.invite.modal.submitButton',
  },
  components: {
    cta: 'dt.invite.components.cta',
    invitesModalLeft: {
      email: 'dt.invite.components.invitesModalLeft.email',
    },
    inviteModalRight: {
      container: 'dt.invite.components.inviteModalRight.container',
      emailAccordionButton: 'dt.invite.components.inviteModalRight.emailAccordionButton',
      email: {
        container: 'dt.invite.components.inviteModalRight.email.container',
        closeButton: 'dt.invite.components.inviteModalRight.email.closeButton',
      },
    },
    invitesViaEmail: {
      emailInput: 'dt.invite.components.invitesViaEmail.emailInput',
      addButton: 'dt.invite.components.invitesViaEmail.addButton',
    },
  },
};
